/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoCreateAgreementDto
 */
export interface WebApiIntegrationsDtoCreateAgreementDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateAgreementDto
     */
    identity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateAgreementDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateAgreementDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateAgreementDto
     */
    name?: string | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoCreateAgreementDto interface.
 */
export function instanceOfWebApiIntegrationsDtoCreateAgreementDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoCreateAgreementDtoFromJSON(json: any): WebApiIntegrationsDtoCreateAgreementDto {
    return WebApiIntegrationsDtoCreateAgreementDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoCreateAgreementDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoCreateAgreementDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'identity': !exists(json, 'identity') ? undefined : json['identity'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function WebApiIntegrationsDtoCreateAgreementDtoToJSON(value?: WebApiIntegrationsDtoCreateAgreementDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'identity': value.identity,
        'email': value.email,
        'phoneNumber': value.phoneNumber,
        'name': value.name,
    };
}

